import Vue from 'vue'
import App from './App'
import router from './router'
import { i18n } from './i18n'
import { store }  from "./stores/index";
const fb = require('./config/firebase.js')

Vue.config.productionTip = false;
Vue.prototype.$firebase = fb; // Permet d'utiliser firebase partout en utilisant $this.fb
Vue.prototype.$translation = i18n;

let app
fb.auth.onAuthStateChanged(user => {
    if (!app) {
        app = new Vue({
            // #app
            el: '#app',
            router,
            components: {
                App
            },
            i18n,
            store,
            template: '<App/>'
        });
    }
})



// WEBPACK FOOTER //
// ./src/main.js